import {handleAction, handleSubState} from 'uix/actions'
import {persistReducer} from 'uix/persist/redux'
import log from 'uix/logging'
import {size} from 'ldash'

import {setLogStreamData, setLogStreamMode, setLogStream} from './actions'
// 20k lines need 100ms for recalc/rerendering in prod
const MAX_LINES = process.env.NODE_ENV !== 'production' ? 5000 : 20000

export const meta = [
  handleSubState(
    'logstream',
    [
      handleAction(setLogStreamData, (logstream, {payload}) => {
        let {lines} = logstream

        if (payload.lines) {
          if (payload.lines == 'FLUSH') {
            lines = []
          } else {
            lines = [...(lines || []), ...payload.lines].slice(-MAX_LINES)
          }
        }
        let isDisconnected = lines && lines.slice(-1)[0]?.startsWith('...disconnected')
        return {...logstream, lines, isDisconnected}
      }),
      persistReducer(
        handleAction(setLogStream, (logstream, {payload}) => {
          let {on, streamidx, channel, limit} = logstream
          if (payload.on !== undefined) {
            on = !!payload.on
          }
          streamidx = payload.streamidx || streamidx
          channel = payload.channel || channel
          limit = payload.limit || limit

          return {...logstream, on, streamidx, channel, limit}
        }),
        {key: 'uix_logstream', whitelist: ['channel']}
      ),
      handleAction(setLogStreamMode, (logstream, {payload}) => ({
        ...logstream,
        mode: payload.mode,
      })),
    ],
    {
      on: false,
      lines: null,
      mode: 'panel',
      channel: 'vls',
      limit: 250,
      isDisconnected: false,
    }
  ),
]
